import React, { useState } from 'react';
import { elders, subElders } from './eldersConf.js';
import ReactMarkdown from 'react-markdown';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const ImageItem = ({ src, name, onClick }) => (
    <div className="image-item" onClick={onClick}>
        <img src={"images/presbiterium/thumbs/" + src} alt={name} />
        <h3>{name}</h3>
    </div>
);

function ModalElderDesc({ name, src, description, onHide }) {
    return (
        <Modal
            show={true}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {name}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <img className="modal-image" src={"images/presbiterium/details/" + src} alt={name} />
                <ReactMarkdown>{description}</ReactMarkdown>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onHide}>Bezárás</Button>
            </Modal.Footer>
        </Modal>
    );
}

export const ImageGrid = () => {

    const [selectedImage, setSelectedImage] = useState(null);
    const [modalShow, setModalShow] = useState(false);

    const handleImageClick = (image) => {
        setSelectedImage(image);
        setModalShow(true); // set modalShow to true when an image is clicked
    };

    const handleModalClose = () => {
        setSelectedImage(null);
        setModalShow(false); // set modalShow to false when the modal is supposed to close
    };

    return (
        <div>
            <div className="PresbiterAll">
                <img src="images/presbiterium/2024/all.jpg" alt='Csoportkép a presbiteri ciklus kezdő együttlétről Dömösön'/>
                <p>Presbiteri ciklus kezdő együttlét Dömösön</p>
            </div>
            <a href='hirdetesek/allasfoglalas_2024.pdf'><center><h2>Dömösi Állásfoglalás</h2></center></a>
            <div class="PresbiterBlock">
                <h1>Presbiterek</h1>
                <div className="image-grid">
                    {elders.map((image, index) => (
                        <ImageItem key={index} src={image.src} name={image.name} onClick={() => handleImageClick(image)} />
                    ))}
                </div>
                <h1>Pótpresbiterek</h1>
                <div className="image-grid">
                    {subElders.map((image, index) => (
                        <ImageItem key={index} src={image.src} name={image.name} onClick={() => handleImageClick(image)} />
                    ))}
                </div>
                {selectedImage && (
                    <ModalElderDesc
                        name={selectedImage.name}
                        src={selectedImage.src}
                        description={selectedImage.description}
                        show={modalShow}
                        onHide={handleModalClose}
                    />
                )}
            </div>
        </div>
    );
};